import { Dialog } from '@chakra-ui/react'
import styled from '@emotion/styled'

import theme from 'styles/theme'

export const LeidStyledModal = styled(Dialog.Content)<{ minWidth?: string }>`
  border-radius: ${theme.token.var('borderRadius.big')};
  padding: 16px;

  border: 1px solid ${theme.token.var('colors.leid.grnn')};
  background-color: ${theme.token.var('white')};

  height: auto;
`

export const LeidStyledHeader = styled(Dialog.Header)`
  padding: 0;
  margin-bottom: 24px;
  font-size: ${theme.token.var('fontSizes.lg')};
  font-weight: 700;
  line-height: 1.5;
`

export const LeidStyledBody = styled(Dialog.Body)`
  padding: 0;
  margin: 0;
  line-height: 1.5;
`

export const LeidStyledOverlay = styled(Dialog.Backdrop)`
  background: rgba(2, 17, 12, 0.9);
`

export const LeidStyledFooter = styled(Dialog.Footer)`
  padding: 0;
`
